import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: null,
    isAuthenticated: false,
    loading: false,
    userInfoPromise: null, // 用于存储正在进行的请求
    userInfoTimestamp: null // 用于记录用户信息的获取时间
  },
  mutations: {
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      state.isAuthenticated = !!userInfo
      state.userInfoTimestamp = Date.now()
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    CLEAR_USER_INFO(state) {
      state.userInfo = null
      state.isAuthenticated = false
      state.userInfoTimestamp = null
    },
    SET_USER_INFO_PROMISE(state, promise) {
      state.userInfoPromise = promise
    }
  },
  actions: {
    async fetchUserInfo({ commit, state }) {
      const token = localStorage.getItem('token')
      if (!token) {
        commit('CLEAR_USER_INFO')
        return null
      }

      // 检查缓存是否有效（5分钟内有效）
      const CACHE_DURATION = 5 * 60 * 1000 // 5分钟
      const now = Date.now()
      if (state.userInfo && 
          state.userInfoTimestamp && 
          (now - state.userInfoTimestamp) < CACHE_DURATION) {
        return state.userInfo
      }
      
      // 如果已经有正在进行的请求，等待该请求完成
      if (state.userInfoPromise) {
        return await state.userInfoPromise
      }

      // 创建一个新的请求Promise
      const userInfoPromise = (async () => {
        commit('SET_LOADING', true)
        try {
          const response = await axios.get('/api/user/info')
          const userInfo = response.data
          commit('SET_USER_INFO', userInfo)
          return userInfo
        } catch (error) {
          console.error('获取用户信息失败:', error)
          commit('CLEAR_USER_INFO')
          // 如果是401错误，清除token并跳转到登录页
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('token')
            localStorage.removeItem('userRole')
            localStorage.removeItem('username')
            localStorage.removeItem('customerInfo')
            window.location.href = '/customer/login'
          }
          return null
        } finally {
          commit('SET_LOADING', false)
          commit('SET_USER_INFO_PROMISE', null) // 清除Promise引用
        }
      })()
      
      // 保存Promise引用
      commit('SET_USER_INFO_PROMISE', userInfoPromise)
      
      return await userInfoPromise
    },
    
    // 强制刷新用户信息（忽略缓存）
    async refreshUserInfo({ commit }) {
      const token = localStorage.getItem('token')
      if (!token) {
        commit('CLEAR_USER_INFO')
        return null
      }

      commit('SET_LOADING', true)
      try {
        const response = await axios.get('/api/user/info')
        const userInfo = response.data
        commit('SET_USER_INFO', userInfo)
        return userInfo
      } catch (error) {
        console.error('刷新用户信息失败:', error)
        commit('CLEAR_USER_INFO')
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('token')
          localStorage.removeItem('userRole')
          localStorage.removeItem('username')
          localStorage.removeItem('customerInfo')
          window.location.href = '/customer/login'
        }
        return null
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    logout({ commit }) {
      localStorage.removeItem('token')
      localStorage.removeItem('userRole')
      commit('CLEAR_USER_INFO')
      commit('SET_USER_INFO_PROMISE', null)
    }
  },
  getters: {
    userInfo: state => state.userInfo,
    isAuthenticated: state => state.isAuthenticated,
    isLoading: state => state.loading,
    authority: state => state.userInfo?.authority,
    employeeId: state => state.userInfo?.employeeId,
    username: state => state.userInfo?.user,
    // 检查用户信息是否过期
    isUserInfoExpired: state => {
      if (!state.userInfo || !state.userInfoTimestamp) return true
      const CACHE_DURATION = 5 * 60 * 1000 // 5分钟
      return (Date.now() - state.userInfoTimestamp) >= CACHE_DURATION
    }
  }
})
